import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';

const VetrineCivitanova = () => {
  return (
    <>
      <Helmet>
        <title>Vetrine Civitanova Marche - Cliccami.net</title>
        <meta name="description" content="Vetrine e negozi di Civitanova Marche" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header onFilterClick={() => {}} />
        <main className="pt-20 pb-12">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground mb-4">
              Vetrine Civitanova Marche
            </h1>
            <p className="font-body text-base text-muted-foreground">
              Pagina in costruzione
            </p>
          </div>
        </main>
      </div>
    </>
  );
};

export default VetrineCivitanova;